"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _query = _interopRequireDefault(require("./query.graphql"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var licensingLogTable = function licensingLogTable() {
  var view = {
    query: _query["default"],
    rowKey: 'logId',
    isAscentOrder: false,
    handle: 'licensingLog',
    columns: [{
      name: 'logId',
      label: 'ID',
      filter: true,
      sort: true
    }, {
      name: 'action',
      label: 'Action',
      filter: true,
      sort: true
    }, {
      name: 'pawnId',
      label: 'Actor Pawn ID',
      filter: true,
      sort: true
    }, {
      name: 'pawn.pawn.label',
      label: 'Actor Pawn Type',
      filter: true,
      sort: true
    }, {
      name: 'sourceId',
      label: 'Source ID',
      filter: true,
      sort: true
    }, {
      name: 'sourceType',
      label: 'Source Type',
      filter: true,
      sort: true,
      render: function render(_ref) {
        var value = _ref.value;
        return value.replace('Cccisd\\Licensing\\Models\\', '');
      }
    }, {
      name: 'targetId',
      label: 'Target ID',
      filter: true,
      sort: true,
      render: function render(_ref2) {
        var value = _ref2.value;
        return value || '-';
      }
    }, {
      name: 'targetType',
      label: 'Target Type',
      filter: true,
      sort: true,
      render: function render(_ref3) {
        var value = _ref3.value;
        return value ? value.replace('Cccisd\\Licensing\\Models\\', '') : '-';
      }
    }, {
      name: 'createdAt',
      label: 'Created At',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "licensingLog",
    saveState: true,
    views: [{
      handle: 'licensingLog',
      title: 'Licensing Log',
      table: view
    }]
  }));
};
var _default = exports["default"] = {
  name: 'licensinglog',
  title: 'Licensing Log',
  content: licensingLogTable()
};